// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__+Zmt1","tabList":"Tab_tabList__tsSRm","tab":"Tab_tab__qLM8k","active":"Tab_active__B2QyS","contentPanel":"Tab_contentPanel__pDzOm"};